@if (faqOverviewResponse$ | async; as faqOverview) {
  <div class="container">
    @for (faqRubric of faqOverview?.faqRubrics; track faqRubric) {
      <div ngbAccordion>
        <div ngbAccordionItem [collapsed]="!(expandFaqRubrics$ | async)">
          <div ngbAccordionHeader>
            <button ngbAccordionToggle class="btn btn-block">
              <div class="u-font-bold">{{ faqRubric?.name }}</div>
            </button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                @for (faqItem of faqRubric?.faqItems; track faqItem; let i = $index) {
                  <div class="faq-item"
                    [ngClass]="getFaqItemClass(i)">
                                <a [routerLink]="
                                    {
                                        cxRoute: getForwardRoute(), params: { faqItemCode: faqItem.code }
                                    } | cxUrl" [queryParams]="{ search: searchTerm$ | async }" class="btn-link">
                      {{ faqItem?.title }}
                      <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
                    </a>
                  </div>
                }
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}